export const version = 'v1';
export const baseDomain = window.baseDomain;
